export default __webpack_public_path__ + "assets/audios/1e3461ac9b1ad0f70f6c1de7c6bd298e.mp3";